import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Button,
    Table,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Input,
    Label
} from 'reactstrap';
import NuovoOrdineContainer from './NuovoOrdineContainer'

/**
 * Used for the Listino Prezzi section. 
 */
export class NuovoOrdineMenu extends Component {

    constructor(props) {
        super(props);

        this.toggleOrdineModal = this.toggleOrdineModal.bind(this);        

        this.state = {
            pendingOrdini: [],
            add: false,
            ordine: {},
            ordineModal: false,
            note: "",
            ordiniInAttesa: [],
            ordiniPresiInCarico: [],
            ordiniInModifica :[],
            avviso:{},
            avvisoModal:false 
            
        };
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
    componentDidMount(){
        const role = sessionStorage.getItem("selectedRole");

        let tempInAttesa = [];
        let tempPresiInCarico = [];
        let tempInModifica = [];

        console.log(role)
        let apiUrl = "";

        if(role === "Agenti"){
            apiUrl = `api/ordini`
        }
        else if(role === "Amministrazione"){
            apiUrl = `api/amministrazione/ordini`
        }

        else if(role === "Controller"){
            apiUrl = `api/controller/ordini`
        }

        fetch(apiUrl, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            console.log(myjson)
            myjson.forEach((ordine, index) => {

                if (ordine.status.trim() === "In Attesa") {
                    tempInAttesa.push({ ordine, index });
                }
                else if (ordine.status.trim() === "Presi In Carico") {
                    tempPresiInCarico.push({ ordine, index })
                }
                else if (ordine.status.trim() === "In Modifica")
                {
                    tempInModifica.push({ ordine, index });
                }
            });

            this.setState({
                ordiniInAttesa: tempInAttesa,
                ordiniPresiInCarico: tempPresiInCarico,
                ordiniInModifica: tempInModifica,
                pendingOrdini: myjson,
            })
        }).catch(e => {

        }); 
    }    

    handleAddNewOrdine = () => {
        this.props.history.push('/nuovoCliente/add')
    }

    handleViewOrdine = (ordineId) => {       
        fetch(`api/ordini/${ordineId}`, {
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                ordine: myjson
            }, () => {
                console.log("stato ordine" + this.state.ordine)
                fetch(`../api/clienti/${this.state.ordine.cliente.codiceCliente}`, {   
                    method: 'GET',
                    headers: new Headers({
                        //Authorization token
                        'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                        //Sets the content type. Necessary for the server to recognize the information
                        'Content-Type': 'application/json' 
                    }),
                    //Changes the response to an object
                }).then(response => response.json())
                .then(myjson => {
                    this.setState({
                        ordine: {
                            ...this.state.ordine,
                            cliente: myjson
                        }
                    }, () => {    
                        console.log(this.state.ordine.cliente)
                        this.SearchAvviso()
                        this.toggleOrdineModal()
                    })
                }).catch(e => {
        
                });
            })
        }).catch(e => {

        });    
    }

    adjustRigaQuantity = (num, index) => {
        const newQuantita = this.state.ordine.rige[index] + num;

        this.setState({
            ordine: {
                ...this.state.ordine,
                rige: this.state.ordine.rige.map(
                    (riga, ind) => ind === index ? {...riga, quantita: newQuantita } : riga
                )
            }
        });
    }

    deleteRiga = (index) => {
        const newRige = this.state.ordine.rige; 

        newRige.splice(index, 1);

        this.setState({
            ordine: {
                ...this.state.ordine,
                rige: newRige
            }
        });        
    }

    refreshPage = () => {
        window.location.reload(false);
}

    

    adjustDataConsegnaRiga = (isoDate, index) => {
        this.setState({
            ordine: {
                ...this.state.ordine,
                rige: this.state.ordine.rige.map(
                    (riga, ind) => ind === index ? {...riga, dataConsegna: isoDate } : riga
                )
            }
        });
    }

    adminApproveOrder = (ordineId) => {
        console.log(`Approved ${ordineId}`);
    }
    adminDisapproveOrder = (ordineId) => {
        console.log(`Disapproved ${ordineId}`)
    }

    toggleOrdineModal = () => {
        const role = sessionStorage.getItem("selectedRole");

        let apiUrl = "";

        if(role === "Agenti"){
            apiUrl = `api/ordini`
        }
        else if(role === "Amministrazione"){
            apiUrl = `api/amministrazione/ordini`
        }

        else if(role === "Controller"){
            apiUrl = `api/controller/ordini`
        }

        fetch(apiUrl, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                pendingOrdini: myjson,
                ordineModal: !this.state.ordineModal
            })

        }).catch(e => {

        });
    }

    handleApprovazione = (nonApprov) => {
        const form = {
            ordineId: this.state.ordine.ordineId,
            nonApprov: nonApprov,
            note: this.state.ordine.note
        }

        console.log(form);

        fetch(`/api/ordini/approve`, {   
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => {
            if(response.status === 200){
                this.toggleOrdineModal();
            }
        })
        .catch(e => {

        });
    }

    handleControllo = (nonApprov) => {
        const form = {
            ordineId: this.state.ordine.ordineId,
            articoli: this.state.ordine.articoli,
            agente: this.state.ordine.agente,
            agenteId: this.state.ordine.agenteId,
            nonApprov: nonApprov,
            note: this.state.ordine.note,
            listino: this.state.ordine.cliente.anagraficaListiniId,
            cliente: this.state.ordine.cliente.codiceCliente
         }

        console.log(form);

        fetch(`api/ordini/update/controller`, {
            method: 'Post',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json'
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => {
            if (response.status === 200) {
                this.toggleOrdineModal();
            }
        })
            .catch(e => {

            });
    }

    handleNoteChange = (e) => {
        const temp = this.state.ordine;

        temp.note = e.target.value;

        this.setState({
            ordine: temp
        })
    }

    handleDelete = (ordine, index) => {

        let ordineId;

        if(ordine.ordine){
            const tempInModifica = this.state.ordiniInModifica;
            const tempInAttesa = this.state.ordiniInAttesa;
            const tempPending = this.state.pendingOrdini;
        
            if (ordine.ordine.status == "In Modifica") {
                tempInModifica.splice(index, 1)
            } else
            {
                tempInAttesa.splice(index, 1);
            }
            tempPending.splice(ordine.index, 1);
            
            this.setState({
                pendingOrdini: tempPending,
                ordiniInAttesa: tempInAttesa,
                ordiniInModifica: tempInModifica
            })

            ordineId = ordine.ordine.ordineId;
        }
        else{
            const tempInModifica = this.state.ordiniInModifica;
            const tempInAttesa = this.state.ordiniInAttesa;
            const tempPending = this.state.pendingOrdini;
            let indexToDelete = 0;

            if (ordine.ordine.status == "In Modifica")
            {
            tempInModifica.forEach((ordine, ind) => {
                if (ordine.index === index) {
                    indexToDelete = ind;
                }
            });
            }
            else
            {
            tempInAttesa.forEach((ordine, ind) => {
                if(ordine.index === index){
                    indexToDelete = ind;
                }
            });
            }

            tempInModifica.splice(indexToDelete, 1);
            tempInAttesa.splice(indexToDelete, 1);
            tempPending.splice(index, 1);
            
            this.setState({
                pendingOrdini: tempPending,
                ordiniInAttesa: tempInAttesa,
                oridniInModifica: tempInModifica
            })

            ordineId = ordine.ordineId;
        }

        fetch(`/api/ordini/delete/${ordineId}`, {   
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => {
            if(response.status === 204){
                throw new Error("Ordine not deleted");
            }
        })
        .catch(e => {

        });
        
    }

    chiudiModal = () => {
        this.setState({
            ordineModal: !this.props.ordineModal
        })
    }
    
    SearchAvviso = () =>
    {
        fetch(`api/clienti/avvisi/${this.state.ordine.cliente.codiceCliente}`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            console.log(myjson)
            this.setState({
                avviso: myjson
            })
            if(this.state.avviso.idAvviso != 0)
            {
                console.log(myjson)
                this.toggleAvvisoModal()
            }
        
        }).catch(e => {
            
        });

    }
    
    toggleAvvisoModal = () => {
        this.setState({
            avvisoModal: !this.state.avvisoModal
        })
    }

    buildOrdiniTable = (titolo, ordini, hasDelete) => {
        return (
            <div>
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", borderTop: "1px solid #011e41", paddingBottom: "5px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>{titolo}</h4>
                        </Col>
                    </Row>
                </Container>
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Table responsive borderless style={{margin: "0", marginTop: "5px"}}>
                                <thead>
                                    <tr>
                                        <th style={{padding: "0", width: "5%"}}></th>
                                        <th style={{padding: "0", width: "19%"}}>Ordine Id</th>
                                        <th style={{padding: "0", width: "19%"}}>Codice Cliente</th>
                                        <th style={{padding: "0", width: "19%"}}>Ragione Sociale</th>
                                        <th style={{padding: "0", width: "19%"}}>Agente</th>
                                        <th style={{padding: "0", width: "19%"}}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ordini.map((ordine, index) => {
                                        return(
                                            <tr key={ordine.ordine ? ordine.ordine.ordineId : ordine.ordineId}>
                                                <th style={{padding: "0", width: "5%"}}>
                                                    {hasDelete ?
                                                        <Button type="submit" 
                                                            onClick={() => this.handleDelete(ordine, index)}
                                                            style={{
                                                                width: "10%", 
                                                                padding: "0px", 
                                                                color: "#011e41", 
                                                                border: "none", 
                                                                backgroundColor: "transparent", 
                                                                marginLeft: "5px", 
                                                                marginRight: "10px"}}
                                                        >
                                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                                        </Button> : null
                                                    }
                                                </th>
                                                <td style={{padding: "0", width: "20%"}}>
                                                    <a style={{ color: "blue", cursor: "pointer" }} onClick={() => this.handleViewOrdine(ordine.ordine ? ordine.ordine.ordineId : ordine.ordine)}>{ordine.ordine ? ordine.ordine.ordineId : ordine.ordineId}</a>
                                                </td>
                                                <td style={{padding: "0", width: "20%"}}>{ordine.ordine ? ordine.ordine.cliente.codiceCliente : ordine.cliente.codiceCliente}</td>
                                                <td style={{padding: "0", width: "20%"}}>{ordine.ordine ? ordine.ordine.cliente.ragSoc : ordine.cliente.ragSoc}</td>
                                                <td style={{padding: "0", width: "20%"}}>{ordine.ordine ? ordine.ordine.agente : ordine.agente}</td>
                                                <td style={{padding: "0", width: "20%"}}>{ordine.ordine ? ordine.ordine.status : ordine.status}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    /**
     * Renders the page
     */
    render() {

        const titolo = (
            <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Nuovi Ordini</h5>
        );

        return (
            <Container fluid style={{minHeight: '75vh'}}> 
                <Container className="d-flex align-items-center" fluid> 
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                            {titolo}
                        </Col>
                    </Row>
                </Container>
                {sessionStorage.getItem('selectedRole') === 'Agenti' || sessionStorage.getItem('selectedRole') === 'Controller'?
                    <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Button type="button" className="text-center" onClick={() => this.props.history.push('/order/add')} style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                    Aggiungi un nuovo ordine
                                </Button>                                                                     
                            </Col>
                        </Row> 
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>                                
                                <Button type="button" className="text-center" onClick={() => this.props.history.push('/ContoDeposito')} style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                    Ritiro conto deposito
                                </Button>                                       
                            </Col>
                        </Row> 
                    </Container> : null
                }   
                {sessionStorage.getItem("selectedRole") === "Agenti" ?
                    <div>
                        {this.buildOrdiniTable("Ordini in Modifica", this.state.ordiniInModifica, true)}
                        {this.buildOrdiniTable("Ordini in Attesa", this.state.ordiniInAttesa, true)}
                        {this.buildOrdiniTable("Ordini Presi in Carico", this.state.ordiniPresiInCarico)}
                    </div> : sessionStorage.getItem("selectedRole") === "Controller" ?
                    <div>
                        {this.buildOrdiniTable("Ordini in Modifica", this.state.ordiniInModifica, true)}
                        {this.buildOrdiniTable("Ordini in Attesa", this.state.ordiniInAttesa, true)}
                    </div>:                         
                        this.buildOrdiniTable("Ordini in Attesa", this.state.ordiniInAttesa)
                }    
                {}
                <Modal zIndex={1} size="xl" isOpen={this.state.ordineModal} toggle={this.toggleOrdineModal} style={{color: "#011e41", width: "100%"}}>
                    {sessionStorage.getItem("selectedRole") === "Agenti" ?
                        <div>
                            <ModalBody>
                                <NuovoOrdineContainer 
                                    isReview={true}
                                    cliente={this.state.ordine.cliente}
                                    articoli={this.state.ordine.articoli}
                                    ordineId={this.state.ordine.ordineId}
                                    ordineDataConsegna={this.state.ordine.ordineDataConsegna}
                                    luogoDiConsegna = {this.state.ordine.luogoDiConsegna}
                                    status = {this.state.ordine.status}
                                    toggleOrdineModal={this.toggleOrdineModal}
                                    opzione={this.state.ordine.tipoOpzione}
                                    note={this.state.ordine.note}/>
                                <Container>
                                    <Row>
                                        <Col className="d-flex justify-content-center" sm={2}>Note:</Col>
                                        <Col sm={10}>
                                            <Input type="textarea" id="note" name="note" style={{ height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px" }} onChange={this.handleNoteChange} value={this.state.ordine.note} />
                                        </Col>
                                    </Row>
                                </Container>   
                            </ModalBody>
                            <ModalFooter>
                                {this.state.ordine.status === "Presi In Carico" ? 
                                    <Container className="d-flex justify-content-center align-items-center" fluid>
                                        <Button className="text-center" style={{width: '50%', padding: '0px', marginRight: "20px", backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.setState({ordineModal: false})}>
                                            Chiudi
                                        </Button>
                                    </Container> : null
                                }
                            </ModalFooter>  
                        </div> : null}
                    {sessionStorage.getItem("selectedRole") === "Controller" ?
                        <div>
                            <ModalBody>
                                <NuovoOrdineContainer
                                    isReview={true}
                                    cliente={this.state.ordine.cliente}
                                    articoli={this.state.ordine.articoli}
                                    ordineId={this.state.ordine.ordineId}
                                    ordineDataConsegna={this.state.ordine.ordineDataConsegna}
                                    luogoDiConsegna = {this.state.ordine.luogoDiConsegna}
                                    status = {this.state.ordine.status}
                                    opzione={this.state.ordine.tipoOpzione}
                                    toggleOrdineModal={this.toggleOrdineModal}
                                    note={this.state.ordine.note} />
                                <Container>
                                    <Row>
                                        <Label for="note" className="d-flex justify-content-center" sm={2}>Note:</Label>
                                        <Col sm={10}>
                                            <Input type="textarea" id="note" name="note" style={{height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px"}} onChange={this.handleNoteChange} value={this.state.ordine.note}/>
                                        </Col>
                                    </Row>
                                </Container>
                               
                            </ModalBody>
                            <ModalFooter>
                                <Container className="d-flex justify-content-center align-items-center" fluid>
                                    <Button className="text-center" style={{ width: '25%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.chiudiModal}>
                                        Ordine NON validato
                                    </Button>
                                    <Button className="text-center" style={{ width: '25%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.handleControllo(false)}>
                                        Ordine VALIDATO
                                    </Button>
                                </Container>
                            </ModalFooter>  
                        </div> : null}               
                    {sessionStorage.getItem("selectedRole") === "Amministrazione" ?
                        <div>
                            <ModalBody>
                                <NuovoOrdineContainer 
                                    isControllo={true}
                                    toggleOrdineModal={this.toggleOrdineModal}
                                    ordineId={this.state.ordine.ordineId}
                                    ordineDataConsegna={this.state.ordine.ordineDataConsegna}
                                    cliente={this.state.ordine.cliente}
                                    articoli={this.state.ordine.articoli}
                                    luogoDiConsegna = {this.state.ordine.luogoDiConsegna}
                                    status = {this.state.ordine.status}
                                    opzione={this.state.ordine.tipoOpzione}/>
                                    <Container style={{width: "100%"}} fluid> 
                                        <Row>
                                            <Col className="d-flex justify-content-center" sm={2}>Note:</Col>
                                            <Col sm={10}>
                                                {this.state.ordine.note}
                                            </Col>
                                        </Row>
                                    </Container>
                            </ModalBody>
                            <ModalFooter>
                                <Container className="d-flex justify-content-center align-items-center" fluid>
                                    <Button className="text-center" style={{ width: '25%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.handleApprovazione(true)}>
                                        respingi ordine
                                    </Button>
                                    <Button className="text-center" style={{ width: '25%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={() => this.handleApprovazione(false)}>
                                        approva ordine
                                    </Button>
                                </Container>
                            </ModalFooter>  
                        </div> : null}
                </Modal>
                <Modal zIndex={10} size="md" isOpen={this.state.avvisoModal} toggle={this.toggleAvvisoModal} style={{color: "#011e41"}} >
                    <ModalHeader>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <h5 style={{ color: "#011e41", fontWeight: "bold", margin: "0px" }}>Attenzione!</h5>
                        </Container>
                    </ModalHeader>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{ width: "100vw", margin: "0px", padding: "0px" }}>
                                    {this.state.cliente && this.state.cliente.pagamento.pagamentoId == '101' ?
                                        <div>
                                            <p>Il cliente ha il pagamento su bolla, ma ha un saldo contabile aperto per: {this.state.avviso.saldo} €</p> 
                                            <p><i>*L’ordine verrà inserito, ma evaso solo dopo autorizzazione dell’azienda.</i></p> 
                                        </div>
                                        : 
                                        <div>
                                            <p>Il cliente ha il pagamento a 30gg, ma ha ancora la fattura del {new Date(this.state.avviso.dataFat).toLocaleDateString()} da pagare.</p>
                                            <p>L'ultimo pagamento fatto su questa fattura è del {this.state.avviso.dataPag != null? new Date(this.state.avviso.dataPag) : '-'}.</p>
                                            <p>Saldo totale da avere: {this.state.avviso.saldo} €</p>
                                            <p><i>*L’ordine verrà inserito, ma evaso solo dopo autorizzazione dell’azienda.</i></p> 
                                        </div>}
                            </Row>
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{ width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }} onClick={this.toggleAvvisoModal} >
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
            </Container> 
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/NuovoOrdineMenuContainer.js